export const createIdempotencyKey = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `idem-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const fetchWithIdempotencyRetry = async (url, options = {}, { retries = 1 } = {}) => {
  const key = options.idempotencyKey || createIdempotencyKey();
  let attempt = 0;
  let lastError = null;

  while (attempt <= retries) {
    try {
      const headers = new Headers(options.headers || {});
      headers.set('Idempotency-Key', key);
      const response = await fetch(url, { ...options, headers });
      return response;
    } catch (error) {
      lastError = error;
      attempt += 1;
      if (attempt > retries) {
        throw lastError;
      }
    }
  }

  throw lastError;
};
